<form [formGroup]='realEstateForm' id='{{formGroupName}}' (ngSubmit)='onSubmit()'>
	
	<div class='step-title service-title' i18n>Real Estate Consultation</div>
	<div class='step-description' i18n>Receive expert assistance in selling/appraising your current property</div>

	<div class='real-estate-fields'>
		<div class='section-title' i18n>How can we help?</div>

		<div class='form-control'>
			<mat-radio-group formControlName='helpType' aria-label='Select an option' class='custom-radio-group'>
				<mat-radio-button value='appraisal'>
					<div class='option'>
						<div class='option-name' i18n>Home Appraisal</div>
					</div>
				</mat-radio-button>
				<mat-radio-button value='sale'>
					<div class='option'>
						<div class='option-name' i18n>Home Sale</div>
					</div>
				</mat-radio-button>
			</mat-radio-group>
		</div>

		<div class='form-control textarea-no-label'>
			<label class='section-title' i18n>Property description</label>
			<mat-form-field appearance="outline" class="full-width">
				<textarea i18n-placeholder placeholder="Describe your home, type of building, size, etc" matInput formControlName='details' rows='5'></textarea>
			</mat-form-field>
		</div>
	</div>

	<!-- Mobile Navigation Buttons -->
	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backThirdParty()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit' type='submit'>
				<ng-container *ngIf='formService.isLastThirdPartyStep()' i18n='buttonSaveSelection'>Save</ng-container>
				<ng-container *ngIf='!formService.isLastThirdPartyStep()' i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>
</form> 